import axios from 'axios'
// import { Message } from 'element-ui' // 或你使用的 UI 库

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API, // 设置默认 base URL（来自 .env）
  timeout: 5000, // 超时时间
  withCredentials: false // 是否携带 cookie
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token && !config.skipToken) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    delete config.skipToken
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data

    if (res.code !== 200) {
      // Message.error(res.message || 'Error')

      if (res.code === 401) {
        // 处理 token 失效
        localStorage.removeItem('token')
      }
	  return res
      // return Promise.reject('Error')
    } else {
      return res
    }
  },
  error => {
    // Message.error('网络异常，请检查网络连接')
    return Promise.reject(error)
  }
)

export default service
